// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  valueIsRequired,
} from 'validators/common'

const validate = v => {
  // Since redux-form v8, first render of the form does not have the actual initial values.
  // https://github.com/redux-form/redux-form/issues/4344
  if (Object.keys(v).length === 0) {
    return
  }

  const err = {}

  err.fileName = valueIsRequired(v.fileName)

  // do not allow / or \ in the value
  if (!err.fileName && (!!~v.fileName.indexOf(/\//) || !!~v.fileName.indexOf(/\\/))) {
    err.fileName = 'Value cannot contain "/" or "\\"'
  }

  // ensure that at least one format is to be exported
  if (!v.pathExportTypes.length) {
    err.pathExportTypes = 'Must export at least one format.'
  }

  return err
}

export default validate
